module.exports = __webpack_public_path__ + "static/img/trade.c1e688a5.png";